
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './BaseAMBACH.html?raw';
import '../../../moreCore/UI/GenericDialog/GenericDialog';
import "../../../moreCore/UI/Floating/Menu";
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import {
    ProjectWizardPromoter1Selector,
    ProjectWizardPromoter2Selector
} from "../../_loadingHelpers/VAMv2";
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";

class BaseAMBACH extends compose(_StatefulSection, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private existingEntity: VAM2types.EvProjectEntity_Base = null;

    afterSetData() {
        let data = this.sourceData as VAM2types.EvProjectEntity_Base;

        if (data.ID) {
            this.webPrivilegeManager.loadPrivilegesForEntity(data, lang.hitch(this, this._onPrivilegesLoaded));
            this.existingEntity = data;

        } else {
            this._onPrivilegesLoaded();
        }
        this.setStartupState("ready");
    }

    onDirtyChange(currentState: boolean) {

    }

    _onChanged(key: string, value: any) {
        //this.setStylesBasedOnData(); // bissl extrem? wird bei jeder kleinen Änderung aufgerufen
    }


    private _onChanged_ArtisticPeriod(key: string, newValue: VAM2types.ArtisticPeriod, oldValue: string) {
        if (this.startupState == "ready") {
            if (newValue) {
                if (newValue.ref_financial_period) {
                    this.setAttributeValue("ref_financial_period", newValue.ref_financial_period);
                }
            }
        }
    }

    private _onChanged_EvProjectName(key: string, newValue: string, oldValue: string) {
        if (newValue) {
            this.emit("displayname", newValue);
        }
    }

    private _onPrivilegesLoaded() {
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.addOnchanged("ev_project_name", lang.hitch(this, this._onChanged_EvProjectName));
        this.addOnchanged("ref_artistic_period", lang.hitch(this, this._onChanged_ArtisticPeriod));

    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(BaseAMBACH);